import { UserType } from 'contracts/Auth';
import { useAuth } from 'hooks';
import React from 'react';
import { useLocation } from 'react-router-dom';

import * as S from './styles';
import { usePermission } from 'hooks/usePermission';

interface RouteBase {
  title: string
  path: string
  blockedRoles?: UserType[]
  permissions?: string[]
}

export const Navigation = () => {
  const location = useLocation();
//   const { userBelongsToAnyOf } = useAuth();
  const { hasPermissionTo } = usePermission()

  const rootPath = '/logistica-reversa/coletas';

  const routesBase: RouteBase[] = [
    { 
      title: 'Coleta de interditados', 
      path: '',
    },
    { 
      title: 'Base Histórica', 
      path: '/historico',
      permissions: ['HISTORY-PICKUPS.INDEX']
    },
  ]

  const isActive = (path: string) => path === location.pathname

  const routes = routesBase.filter(
    item => {
      const passBlockedRoles = !item.blockedRoles || !hasPermissionTo(item.blockedRoles as any);
      const passPermissions = !item.permissions || hasPermissionTo(item.permissions);
      
      return passBlockedRoles && passPermissions;
    }
  )

  return (
    <S.Container>
      {routes.map(route => (
        <S.Button
          key={route.path}
          to={`${rootPath}${route.path}`}
          className={isActive(`${rootPath}${route.path}`) ? 'actived': ''}
        >
          {route.title}
        </S.Button>
      ))}
    </S.Container>
  );
};
